import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllGeofenceSummaryReport } from "../../../Apis/GeofenceReports/geofenceSummaryReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import Loader from "../../../Common/Loader/loader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import RoutepointTransactionStore from "./store/routepointTransactionStore";
import { useFilterStore } from "../../AssetVehicle/store/useFilterStore";
import RouteSupervisorStore from "../../RouteSupervisor/store/routeSupervisorStore";
const RoutepointTransactionReport = ({ t }) => {
    const { fetchRoutepointTransactionReportsApi, routeTransactionData, loading } = RoutepointTransactionStore()
    const { fetchRouteSupervisorData, routeSupervisorData, } = RouteSupervisorStore();
    const {
        fetchFilterZones,
        fetchAllCircles,
        zones,
        allCircles,

    } = useFilterStore();
    console.log(allCircles)
    const headers = ["routePointName",
        "routePointTypeName",
        "routePointCode", "routeCode", "routeName", "zone", "ward", "date",
        "latitude",
        "longitude",
        "routeSupervisorName", "routePointStatusName"

    ];
    const [routeCode, setRouteCode] = useState("");
    const [routeSupervisorName, setRouteSupervisorName] = useState("");

    const [zoneId, setZoneId] = useState("");
    const [circleId, setCircleId] = useState("");
    const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
    const [startDate, setStartDate] = useState(getStartOfCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDateTime());
    const isProd = isGHMC();
    useEffect(() => {
        fetchRoutepointTransactionReportsApi();
        fetchFilterZones()
        fetchAllCircles()
        fetchRouteSupervisorData()
    }, []);

    const formatDateForDisplay = (dateString) => {
        const date = new Date(dateString);
        const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
        return date.toLocaleString("en-GB", options).replace(",", "");
    };

    const transformedData = routeTransactionData.map((item) => ({
        ...item,
        status: item.isActive ? "Active" : "Inactive",
        date: formatDateForDisplay(item.createdDate) || "N/A",
        routePointName: item.collectionPointName || "N/A",
        routePointTypeName: item.collectionPointTypeName || "N/A",
        startingRoutePoint: item.startingCollectionPoint || "N/A",
        endingRoutePoint: item.endingCollectionPoint || "N/A",
        referencePointCode: item.referencePointCode || "N/A",
        zone: item.zoneName || "N/A",
        ward: item.circleName || "N/A",
        routePointCode: item.collectionPointCode || "N/A",
        pickupDateTime: formatDateForDisplay(item.beforeDateTime) || "N/A",
        latitude: item.latitude || "N/A",
        longitude: item.longitude || "N/A",
        beforeImage: item.beforeImageURL || "N/A",
        afterImage: item.afterImageURL || "N/A",
        referencePointCode: item.referencePointCode || "N/A",
        routeSupervisorName: item.routeSupervisorName || "N/A",
        numberOfTimesToClear: item.referencePointCode || "N/A",
        routePointStatus: item.routePointStatus || "N/A",
        routeCode: item.routeCode || "N/A",
        routeName: item.routeName || "N/A"


    }));


    const options = { day: "numeric", month: "numeric", year: "numeric" };
    const generationTime = ` ${new Date()
        .toLocaleString("en-GB", options)
        .replace(/\//g, "/")}`;

    // Function to format date-time as DD-MM-YYYY HH:MM
    const formatDateTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        }).replace(",", ""); // Removes comma between date and time
    };


    const downloadAsExcel = async () => {
        const formattedStartDate = formatDateTime(startDate);
        const formattedEndDate = formatDateTime(endDate);
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Route Point Transaction Report");

        const boldFont = { bold: true, size: 12 };
        const headingFont = { bold: true, size: 14 };
        const centerAlign = { horizontal: "center" };

        // Title
        const reportTitle = "";
        worksheet.addRow([reportTitle]);
        worksheet.mergeCells(1, 1, 1, headers.length + 1);
        worksheet.getCell(1, 1).font = headingFont;
        worksheet.getCell(1, 1).alignment = centerAlign;

        // Timestamp
        const downloadDateTime = `Report on: ${formattedDate}, ${formattedTime}`;
        worksheet.addRow([downloadDateTime]);
        worksheet.mergeCells(2, 1, 2, headers.length + 1);
        worksheet.getCell(2, 1).font = boldFont;
        worksheet.getCell(2, 1).alignment = centerAlign;

        // Date range
        const downloadHeading = `Route Point Transaction Report ${formattedStartDate} to ${formattedEndDate} - (at ${getCurrentDateTime1()})`;
        worksheet.addRow([downloadHeading]);
        worksheet.mergeCells(3, 1, 3, headers.length + 1);
        worksheet.getCell(3, 1).font = boldFont;
        worksheet.getCell(3, 1).alignment = centerAlign;

        // Spacer
        worksheet.addRow([""]);
        const formatHeader = (header) => {
            return header
                .replace(/([a-z])([A-Z])/g, "$1 $2") // insert space before capital letters
                .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter
        };

        const formattedHeaders = headers.map(formatHeader);


        // Table headers
        const tableHeaderRow = worksheet.addRow(["S.No", ...formattedHeaders]);
        tableHeaderRow.eachCell((cell) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "left" };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" },
            };
        });

        // Table data
        transformedData.forEach((item, index) => {
            const rowData = [
                index + 1,
                ...headers.map((key) => item[key] ?? "N/A"),
            ];
            const row = worksheet.addRow(rowData);
            row.eachCell((cell) => {
                cell.alignment = { horizontal: "left" };
            });
        });

        // Column widths
        worksheet.columns = [{ width: 12 }, ...headers.map(() => ({ width: 30 }))];

        // Trigger download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Route_Point_Transaction_Report_${formattedDate}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        fetchRoutepointTransactionReportsApi(startDate, endDate, zoneId, circleId ? circleId : "", routeCode, routeSupervisorName);
    };




    const calculateGVPTotals = (data) => {
        const totals = {
            sno: 'Total',
            siteName: 'Total',
            vehicleInCount: 0,
            vehicleOutCount: 0,
        };

        data.forEach(row => {
            totals.vehicleInCount += row.vehicleInCount || 0;
            totals.vehicleOutCount += row.vehicleOutCount || 0;
        });
        return totals;
    };

    const totalZoneRow = calculateGVPTotals(getAllTripsTonnage);
    const GVPDataWithTotal = [...getAllTripsTonnage, totalZoneRow];

    return (
        <>
            {loading ? ( // Check isLoading state and show loader if true
                <Loader />
            ) : (
                <div style={{ width: "100%" }}>
                    <div className="content">
                        <div className="page-content">
                            <div className="d-flex justify-content-between">
                                <h4 class="text-start mb-3">{t("Route Point Transaction Report")} </h4>

                            </div>

                            <div className="card">
                                <div className="card-body p-3">
                                    <form onSubmit={handleFormSubmit}>
                                        <div className="row align-items-end">
                                            <div className="col-md-12">
                                                <div className="row" style={{ textAlign: "left" }}>
                                                    <div className="col-md-3">
                                                        <label>From Date & Time</label>
                                                        <input
                                                            type="datetime-local"
                                                            name="FromDate"
                                                            style={inputStyle}
                                                            value={startDate}
                                                            className="form-control"
                                                            max={endDate ? endDate : getCurrentDateTime()}
                                                            onChange={(e) => setStartDate(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>To Date & Time</label>
                                                        <input
                                                            type="datetime-local"
                                                            name="ToDate"
                                                            style={inputStyle}
                                                            className="form-control"
                                                            value={endDate}
                                                            min={startDate}
                                                            max={getCurrentDateTime()}
                                                            onChange={(e) => setEndDate(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ZoneId">Zone</label>
                                                        <select
                                                            name="ZoneId"
                                                            className="form-select"
                                                            value={zoneId}
                                                            onChange={(e) => {
                                                                const selectedZone = e.target.value;
                                                                setZoneId(selectedZone);
                                                                setCircleId(""); 
                                                            }}

                                                        >
                                                            <option value="">Select</option>
                                                            {zones &&
                                                                zones
                                                                    ?.filter((zone) => zone.isActive)
                                                                    .map((zone) => (
                                                                        <option key={zone.zoneId} value={zone.zoneId}>
                                                                            {zone.zoneName}
                                                                        </option>
                                                                    ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="WardId">Ward</label>
                                                        <select
                                                            className="form-select"
                                                            value={circleId || ""}
                                                            onChange={(e) => setCircleId(e.target.value)}
                                                        >
                                                            <option value="">Select</option>
                                                            {allCircles
                                                                .filter(
                                                                    (circle) =>
                                                                        (circle.zoneId) == (zoneId) && circle.isActive
                                                                )
                                                                .map((circle) => (
                                                                    <option key={circle.circleId} value={circle.circleId}>
                                                                        {circle.circleName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <label>Route Code</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={routeCode}
                                                            onChange={(e) => setRouteCode(e.target.value)}
                                                            placeholder="Enter Route Code"
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <label>Route Supervisor</label>
                                                        <select
                                                            className="form-select"
                                                            value={routeSupervisorName}
                                                            onChange={(e) => setRouteSupervisorName(e.target.value)}
                                                        >
                                                            <option value="">Select</option>
                                                            {
                                                                // Dynamically render supervisor names from the data if available
                                                                routeSupervisorData
                                                                    .filter(routeSupervisor => routeSupervisor.isActive)
                                                                    .map((routeSupervisor, index) => (
                                                                        <option key={routeSupervisor.routeSupervisorId} value={routeSupervisor.routeSupervisorId}>
                                                                            {routeSupervisor.routeSupervisorName}
                                                                        </option>
                                                                    ))
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <button
                                                                type="submit"
                                                                className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                                                            >
                                                                Search
                                                            </button>
                                                            <button className="btn btn-excel mt-4" onClick={downloadAsExcel}>
                                                                <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </form>
                                    <div className="mt-3">
                                        <TableComponent
                                            DataFetchURL={transformedData}
                                            headers={headers}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// Rest of the component remains the same

export default withTranslation()(RoutepointTransactionReport);

// Styles for input and button
const inputStyle = {
    border: "1px solid #E2E2E2",
    padding: "15px",
};

const buttonStyle = {
    border: "1px solid #E2E2E2",
    borderRadius: "5px",
    color: "#fff",
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
};
